var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-row',{staticClass:"mod03"},[_c('el-col',{attrs:{"span":24}},[_c('ul',[_c('li',[_c('div',{style:({width: '100%', height: '80vh'}),attrs:{"id":"myChartBar"}})])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }